module.exports = __webpack_public_path__ + "static/media/03-4-recption--mobile.52f20d80.webp";